import { PanoControls } from ".";

let isFirstTouch = false;
let numTouching = 0;
let pinchStart = null;
let pinchEnd = null;

export const touchToMouse = (controls: PanoControls, event, type = 'move') => {
  let touches = event.changedTouches;

  // The only event allowed during 3d mode is touchend (mouseup). Since we only allow this
  // event to be passed along we need to pretend that we pressed down first
  if (controls.orbit.state) {
    if (event.type !== "touchend") {
      return;
    }
    controls.mouseControls.upEnabled = true;
  }

  if (type === "move") {
    // touchstart will increment numTouching
    if (event.type === "touchstart") {
      if (numTouching === 0) {
        isFirstTouch = true;
        numTouching = numTouching + 1;
      } else {
        isFirstTouch = false;
      }
    }

    // touchend will decrement numTouching
    if (event.type === "touchend") {
      numTouching = Math.max(0, numTouching - 1);
    }
  }

  // Single touch, so create a fake mouse event instead
  if (touches.length === 1) {
    // we dont want to move after a pinch effect (it will be super glitchy)
    if (type === "move") {
      if (event.type === "touchmove") {
        if (!isFirstTouch) {
          return null;
        }
      }
    }

    let first = touches[0];
    let eventType = "";

    switch (event.type) {
    case "touchstart":
      eventType = "mousedown";
      break;
    case "touchmove":
      eventType = "mousemove";
      break;
    case "touchend":
      eventType = "mouseup";
      break;
    default:
      return null;
    }

    event = new MouseEvent(eventType, {
      bubbles: true,
      cancelable: true,
      view: window,
      detail: 1,
      screenX: first.screenX,
      screenY: first.screenY,
      clientX: first.clientX,
      clientY: first.clientY,
      ctrlKey: false,
      altKey: false,
      shiftKey: false,
      metaKey: false,
      button: 0
    });
    return event;
  }

  // 2 finger touch (zoom in or out)
  if (touches.length === 2) {
    if (event.type === "touchmove") {
      let dist = Math.sqrt(
        (touches[0].clientX - touches[1].clientX) * (touches[0].clientX - touches[1].clientX) +
        (touches[0].clientY - touches[1].clientY) * (touches[0].clientY - touches[1].clientY)
      );

      if (pinchStart === null) {
        pinchStart = dist;
      } else {
        pinchEnd = dist;
        let pinchMove = pinchStart - pinchEnd;
        let sign = pinchMove / (Math.abs(pinchMove));

        event = new MouseEvent('wheel', {
          bubbles: true,
          cancelable: true,
          view: window,
          screenX: 0,
          screenY: 0,
          clientX: 0,
          clientY: 0,
          detail: sign,
          ctrlKey: false,
          altKey: false,
          shiftKey: false,
          metaKey: false,
          button: 0
        });
        event.deltaY = sign;
        pinchStart = null;

        return event;
      }
    }
  }

  return null;
};

export const onLongPress = (element, event) => {
  let newEvent = new MouseEvent('mouseup', {
    bubbles: true,
    cancelable: true,
    view: window,
    detail: 1,
    screenX: event.changedPointers[0].screenX, // event.screenX,
    screenY: event.changedPointers[0].screenY, // event.screenY,
    clientX: event.changedPointers[0].clientX, // event.clientX,
    clientY: event.changedPointers[0].clientY, // event.clientY,
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
    button: 2
  });

  element.dispatchEvent(newEvent);
};

export const onDoubleTap = (element, event) => {
  let pointer = event.changedPointers[0];
  let newEvent = new MouseEvent('dblclick', {
    bubbles: true,
    cancelable: true,
    view: window,
    detail: 1,
    screenX: pointer.screenX,
    screenY: pointer.screenY,
    clientX: pointer.clientX,
    clientY: pointer.clientY,
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
    button: 0
  });

  element.dispatchEvent(newEvent);
};
